export default "__VITE_ASSET__cbd74d84__"